/**
 * Simple date utility to convert UTC dates to local timezone
 */

/**
 * Converts UTC date string to local timezone with timezone abbreviation
 * @param utcDateString - UTC date string
 * @returns Formatted string like '07 Aug 2025, 03:55 PM IST'
 * 
 * Example usage:
 * formatToLocalTime('2025-08-07T10:25:00Z') // Returns: '07 Aug 2025, 03:55 PM IST'
 */
export const formatToLocalTime = (utcDateString: string | Date): string => {
  try {
    const date = new Date(utcDateString);
    
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    // Get user's timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Format date with timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: timezone,
      timeZoneName: 'short'
    });

    return formatter.format(date);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};
